/**
 * Catalogo versionado de permissoes granulares (US 1.1).
 * Padrao: modulo.recurso.acao
 */

export const PERMISSION_CATALOG_VERSION = "2026-04-29";

export const PERMISSION_CATALOG = [
  "dashboard.resumo.visualizar",
  "usuarios.usuario.visualizar",
  "usuarios.usuario.criar",
  "usuarios.usuario.editar",
  "usuarios.usuario.excluir",
  "alunos.aluno.visualizar",
  "alunos.aluno.criar",
  "alunos.aluno.editar",
  "alunos.aluno.excluir",
  "monitores.monitor.visualizar",
  "monitores.monitor.criar",
  "monitores.monitor.editar",
  "monitores.monitor.excluir",
  "nucleos.nucleo.visualizar",
  "nucleos.nucleo.criar",
  "nucleos.nucleo.editar",
  "nucleos.nucleo.excluir",
  "salas.sala.visualizar",
  "salas.sala.criar",
  "salas.sala.editar",
  "salas.sala.excluir",
  "turmas.turma.visualizar",
  "turmas.turma.criar",
  "turmas.turma.editar",
  "turmas.turma.excluir",
  "atividades.atividade.visualizar",
  "atividades.atividade.criar",
  "atividades.atividade.editar",
  "atividades.atividade.excluir",
  "matriculas.matricula.visualizar",
  "matriculas.matricula.criar",
  "matriculas.matricula.editar",
  "matriculas.matricula.excluir",
  "frequencia.lancamento.visualizar",
  "frequencia.lancamento.criar",
  "frequencia.lancamento.editar",
  "frequencia.lancamento.excluir",
  "avaliacoes.avaliacao.visualizar",
  "avaliacoes.avaliacao.criar",
  "avaliacoes.avaliacao.editar",
  "avaliacoes.avaliacao.excluir",
  "planejamentos.planejamento.visualizar",
  "planejamentos.planejamento.criar",
  "planejamentos.planejamento.editar",
  "planejamentos.planejamento.excluir",
  "galeria.midia.visualizar",
  "galeria.midia.criar",
  "galeria.midia.editar",
  "galeria.midia.excluir",
  "relatorios.relatorio.visualizar",
  "relatorios.relatorio.criar",
  "relatorios.relatorio.editar",
  "relatorios.relatorio.excluir",
  "ocorrencias.ocorrencia.visualizar",
  "ocorrencias.ocorrencia.criar",
  "ocorrencias.ocorrencia.editar",
  "ocorrencias.ocorrencia.excluir",
  "auditoria.log.visualizar",
];

export const CRITICAL_SCREEN_PERMISSION_MAP = {
  "/dashboard": ["dashboard.resumo.visualizar"],
  "/usuarios": ["usuarios.usuario.visualizar"],
  "/gestao": ["alunos.aluno.visualizar", "monitores.monitor.visualizar"],
  "/nucleos-atividades": ["nucleos.nucleo.visualizar", "atividades.atividade.visualizar"],
  "/matriculas": ["matriculas.matricula.visualizar"],
  "/gerenciamento-matriculas": ["matriculas.matricula.editar"],
  "/operacoes": [
    "frequencia.lancamento.visualizar",
    "avaliacoes.avaliacao.visualizar",
    "ocorrencias.ocorrencia.visualizar",
  ],
  "/planejamentos": ["planejamentos.planejamento.visualizar"],
  "/galeria": ["galeria.midia.visualizar"],
  "/ocorrencias": ["ocorrencias.ocorrencia.visualizar"],
  // Permite entrada em Relatórios também para quem só tem acesso de auditoria.
  "/relatorios": ["relatorios.relatorio.visualizar", "auditoria.log.visualizar"],
};
